import { CLEAR_HISTORY, GO_BACK, HISTORY, SET_HISTORY, SET_SELECTED_BUTTON } from '../actions/types';

const initialState = {
  history: [],
  historyBack: [],
  screenName: 'login',
  selectedButton: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_HISTORY:
      const newHistoryBack = [...state.historyBack, payload.item];
      return { ...state, history: payload.history, historyBack: newHistoryBack };
    case HISTORY:
      console.log(state.historyBack);
      return { ...state, screenName: payload.screenName, historyBack: [...state.historyBack, payload] };
    case GO_BACK:
      return { ...state, screenName: payload.screenName, historyBack: [...state.historyBack].slice(0, -1) };
    case CLEAR_HISTORY:
      return { ...state, screenName: '', historyBack: [] };
    case SET_SELECTED_BUTTON:
      return { ...state, selectedButton: payload };
    default:
      return state;
  }
};
